export default "__VITE_ASSET__ocq_8qIT__"